import { Fragment } from 'react/jsx-runtime'
import { motion } from 'motion/react'

export const Home = () => {
	const handleScroll = (id: string) => {
		const section = document.getElementById(id)
		if (section) {
			section.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<Fragment>
			<div className="relative bg-[#3063B6]">
				<div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 w-5/6 aspect-square bg-[radial-gradient(#ffffff3b,_#3063B6_60%)] pointer-events-none" />
				<img
					className="absolute right-0 md:top-0 top-5 md:w-80 w-1/2 -rotate-90"
					src={require('@/assets/images/doodle.png')}
					alt="macsready"
				/>
				<section id="home" className="relative md:h-screen h-[700px] z-10">
					<div className="flex justify-between md:p-16 p-4">
						<img
							className="relative md:h-16 h-12 md:mx-0 mx-auto md:mt-0 mt-8"
							src={require('@/assets/images/logo.png')}
							alt="logo"
						/>
						<div>
							<div className="md:flex hidden items-center gap-5">
								<div
									className="font-medium text-lg text-white cursor-pointer"
									onClick={() => handleScroll('program')}
								>
									Program
								</div>
								<div
									className="font-medium text-lg text-white cursor-pointer"
									onClick={() => handleScroll('product')}
								>
									Product
								</div>
								<a
									href="https://member.macsready.id/member"
									className="px-5 py-1 pb-1.5 font-medium text-lg text-white bg-[linear-gradient(125deg,_#EB4557_50%,_#F9BB07_80%)] rounded-full cursor-pointer"
								>
									Login
								</a>
							</div>
						</div>
					</div>
					<div className="w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
						<div className="relative pointer-events-none">
							<div className="absolute top-0 left-1/2 -translate-x-1/2 font-bold md:text-5xl text:base text-center text-shadow">
								<div className="translate-x-1 translate-y-1 whitespace-nowrap">
									Buy, Open, Eat and Get Points
								</div>
							</div>
							<div className="absolute top-0 left-1/2 -translate-x-1/2 font-bold md:text-5xl text:base text-center text-outline whitespace-nowrap z-10">
								Buy, Open, Eat and Get Points
							</div>
							<div className="absolute top-0 left-1/2 -translate-x-1/2 font-bold md:text-5xl text:base text-center text-white whitespace-nowrap z-20">
								Buy, Open, Eat and Get Points
							</div>
						</div>
						<div className="font-normal md:text-xl text-sm text-white text-center mt-20">
							Beli produk MACSREADY scan kode unik, koleksi pointnya
							<br />& menangkan hadiah ekslusif MACSREADY
						</div>
						<div className="flex md:flex-row flex-col justify-center items-center gap-5 mt-10">
							<a
								href="https://member.macsready.id/member"
								className="px-5 py-2 pb-2.5 font-medium md:text-lg text-sm text-[#96DAFF] border border-[#96DAFF] rounded-full"
							>
								Login Sekarang
							</a>
							<a
								href="https://member.macsready.id/member/register"
								className="px-5 py-2 pb-2.5 font-medium md:text-lg text-sm text-white bg-[linear-gradient(125deg,_#EB4557_50%,_#F9BB07_80%)] rounded-full"
							>
								Register
							</a>
						</div>
					</div>
					<div className="absolute md:bottom-80 md:-translate-x-32 -translate-x-10">
						<img
							className="md:h-60 h-20 animate-spin [animation-duration:20s] will-change-transform"
							src={require('@/assets/images/star.png')}
							alt="macsready"
						/>
					</div>
					<img
						className="absolute bottom-0 left-0 md:h-96 h-auto md:w-auto w-2/5"
						src={require('@/assets/images/character-1.png')}
						alt="macsready"
					/>
					<img
						className="absolute -bottom-10 md:left-60 left-20 md:w-80 w-1/3"
						src={require('@/assets/images/product.png')}
						alt="macsready"
					/>
					<div className="absolute bottom-40 right-0 md:translate-x-32 translate-x-10">
						<img
							className="md:h-80 h-28 animate-spin [animation-duration:20s] will-change-transform"
							src={require('@/assets/images/star.png')}
							alt="macsready"
						/>
					</div>
					<img
						className="absolute bottom-0 right-0 md:h-96 h-auto md:w-auto w-2/5"
						src={require('@/assets/images/character-2.png')}
						alt="macsready"
					/>
					<img
						className="absolute bottom-0 md:right-48 right-10 md:w-80 w-1/3"
						src={require('@/assets/images/macaroni.png')}
						alt="macsready"
					/>
				</section>
				<div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full bg-[linear-gradient(0deg,_#3063b6_20%,_transparent)] h-20 z-10" />
			</div>
			<img
				className="relative w-full bg-[#3063b6] z-20"
				src={require('@/assets/images/wave-blue.svg').default}
				alt="macsready"
			/>
			<section id="program" className="relative bg-[#219AD5] p-4 z-30">
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{
						duration: 0.5,
						ease: 'easeOut'
					}}
					className="font-semibold md:text-5xl text-xl text-center text-white"
				>
					Langkah Mudah untuk
					<br />
					Mengumpulkan Poin MACSREADY
				</motion.div>
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{
						delay: 0.3,
						duration: 0.5,
						ease: 'easeOut'
					}}
					className="font-normal md:text-lg text-sm text-center text-white mt-10"
				>
					Kumpulkan poin dengan mudah setiap kali kamu bertransaksi dan nikmati
					berbagai reward menarik dari MACSREADY.
				</motion.div>
				<div className="flex md:flex-row flex-col justify-center items-center gap-5 mt-10 max-w-6xl mx-auto md:mb-40 mb-20">
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3 flex flex-col gap-5 bg-white p-10 rounded-xl text-center opacity-0"
					>
						<div className="flex justify-center items-center w-4/5 aspect-square rounded-full bg-[#FFCF1B] overflow-hidden mx-auto">
							<img
								className="w-1/2"
								src={require('@/assets/images/scan.png')}
								alt="macsready"
							/>
						</div>
						<div className="font-semibold md:text-2xl text-xl text-center text-[#0579AE]">
							Scan Kode Unik
						</div>
						<div className="font-normal md:text-base text-sm text-center text-[#0579AE]">
							Mulai kumpulkan poin dari setiap langganan produk MACSREADY
							favoritmu. Makin sering langganan, makin banyak poin yang kamu
							dapatkan!
						</div>
					</motion.div>
					{/* <motion.div
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3 flex flex-col gap-5 bg-white p-10 rounded-xl text-center opacity-0"
					>
						<div className="flex justify-center items-center w-4/5 aspect-square rounded-full bg-gradient-to-b from-[#E31B25] to-[#B80911] mx-auto">
							<img
								className="w-1/2"
								src={require('@/assets/images/upload.png')}
								alt="macsready"
							/>
						</div>
						<div className="font-semibold md:text-2xl text-xl text-center text-[#0579AE]">
							Upload Konten Product
						</div>
						<div className="font-normal md:text-base text-sm text-center text-[#0579AE]">
							Lorem ipsum dolor sit adipiscing elit, sed do eiusmod tempor
							incididunt ut labore et dolore magna aliqua
						</div>
					</motion.div> */}
					<motion.div
						initial={{ opacity: 0, x: 50 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3 flex flex-col gap-5 bg-white p-10 rounded-xl text-center opacity-0"
					>
						<div className="flex justify-center items-center w-4/5 aspect-square rounded-full bg-[#BBAD89] mx-auto">
							<img
								className="w-1/2"
								src={require('@/assets/images/point.png')}
								alt="macsready"
							/>
						</div>
						<div className="font-semibold md:text-2xl text-xl text-center text-[#0579AE]">
							Terus Kumpulkan
						</div>
						<div className="font-normal md:text-base text-sm text-center text-[#0579AE]">
							Jangan berhenti kumpulin poinnya! Tukarkan poinmu dengan berbagai
							hadiah menarik dan nikmati keseruannya bersama MACSREADY.
						</div>
					</motion.div>
				</div>
			</section>
			<section id="product" className="relative bg-white h-96">
				<img
					className="block relative w-full bg-[#219AD5] z-20"
					src={require('@/assets/images/wave-white.svg').default}
					alt="macsready"
				/>
				<div className="absolute md:-top-1/2 -top-10 md:-translate-x-32 -translate-x-10 z-50">
					<img
						className="md:h-80 h-20 animate-spin [animation-duration:20s] will-change-transform"
						src={require('@/assets/images/star.png')}
						alt="macsready"
					/>
				</div>
				<div className="flex md:flex-row flex-col justify-between gap-4 max-w-6xl w-full mx-auto p-4">
					<motion.div
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="font-semibold md:text-5xl text-xl text-[#0579AE]"
					>
						Langganan Hemat
						<br />
						Poin Melimpah
					</motion.div>
					<motion.div
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="font-normal md:text-base text-sm text-[#0579AE] max-w-96"
					>
						Nikmati berbagai keuntungan spesial untuk setiap transaksi.
						Kumpulkan poin lebih banyak dan tukarkan dengan reward seru
						favoritmu.
					</motion.div>
				</div>
				<div className="relative flex md:flex-row flex-col justify-center items-center gap-5 max-w-6xl mx-auto md:mt-20 p-4 z-20">
					<motion.div
						initial={{ opacity: 0, x: 100 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{
							delay: 0.3,
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3"
					>
						<img
							className="w-full"
							src={require('@/assets/images/product-1.png')}
							alt="macsready"
						/>
					</motion.div>
					<motion.div
						initial={{ opacity: 0, x: 100 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{
							delay: 0.4,
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3"
					>
						<img
							className="w-full"
							src={require('@/assets/images/product-2.png')}
							alt="macsready"
						/>
					</motion.div>
					<motion.div
						initial={{ opacity: 0, x: 100 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{
							delay: 0.5,
							duration: 0.5,
							ease: 'easeOut'
						}}
						className="basis-1/3"
					>
						<img
							className="w-full"
							src={require('@/assets/images/product-3.png')}
							alt="macsready"
						/>
					</motion.div>
				</div>
				<div>
					<img
						className="block relative w-full"
						src={require('@/assets/images/footer.svg').default}
						alt="macsready"
					/>
					<div className="flex flex-col md:flex-row gap-5 justify-between w-full bg-[#FFCF1B] pb-20">
						<div className="font-medium md:text-base text-sm md:text-left text-center max-w-6xl mx-auto z-20 bg-[#FFCF1B]">
							<div>MACSREADY All Right Reserved.</div>
						</div>
						<div className="flex gap-2 font-medium md:text-base text-sm md:text-left text-center max-w-6xl mx-auto z-20 bg-[#FFCF1B]">
							<div>Powered by</div>
							<img
								className="h-5"
								src={require('@/assets/images/loyalid.png')}
								alt="macsready"
							/>
						</div>
					</div>
				</div>
			</section>
		</Fragment>
	)
}
